import type { UiLanguageCode } from '@/lib/ui-languages';

/** Clés UI + aide pour Paramètres du site (`/settings?tab=site`). */
export const loSiteSettingsLocales: Record<UiLanguageCode, Record<string, string>> = {
  fr: {
    'loSiteSettings.back': '← Paramètres',
    'loSiteSettings.pageTitle': 'Paramètres du site',
    'loSiteSettings.pageSubtitle': 'Identité, domaine, marque blanche, audience et options du site public.',
    'loSiteSettings.themeCallout': 'Le thème visuel se modifie dans l’éditeur de pages (<link>{{name}}</link>), onglet Thème.',
    'loSiteSettings.themeLink': 'Site web',
    'loSiteSettings.save': 'Enregistrer les paramètres',
    'loSiteSettings.saving': 'Enregistrement…',
    'loSiteSettings.copied': 'Copié dans le presse-papiers',
    'loSiteSettings.copyFail': 'Copie impossible',
    'loSiteSettings.help.openAria': 'Afficher l’aide pour {{tab}}',
    'loSiteSettings.help.closeAria': 'Fermer le panneau d’aide',
    'loSiteSettings.help.title': 'Aide',
    'loSiteSettings.help.keepOpen': 'Garder ouvert',
    'loSiteSettings.help.empty': 'Cliquez sur l’icône ? d’un onglet pour afficher l’aide ici, à côté du formulaire.',
    'loSiteSettings.help.steps': 'Étapes',
    'loSiteSettings.tabs.identity': 'Identité',
    'loSiteSettings.tabs.language': 'Langue',
    'loSiteSettings.tabs.analytics': 'Audience',
    'loSiteSettings.tabs.domain': 'Domaine',
    'loSiteSettings.tabs.legal': 'Légal',
    'loSiteSettings.tabs.branding': 'Marque blanche',
    'loSiteSettings.tabs.features': 'Options',
    'loSiteSettings.tabs.payments': 'Encaissement',
    'loSiteSettings.identity.title': 'Identité du site',
    'loSiteSettings.identity.desc': 'Nom affiché dans l’en-tête, le pied de page et les métadonnées.',
    'loSiteSettings.identity.name': 'Nom du site',
    'loSiteSettings.identity.placeholder': 'Mon site de formation',
    'loSiteSettings.identity.saving': 'Enregistrement du nom…',
    'loSiteSettings.identity.dirty': 'Nom modifié — enregistrement à la sortie du champ ou via Enregistrer.',
    'loSiteSettings.identity.slug': 'Identifiant public :',
    'loSiteSettings.language.title': 'Langue de rédaction',
    'loSiteSettings.language.desc': 'Langue source pour la rédaction et la traduction automatique à la publication.',
    'loSiteSettings.language.label': 'Langue principale du contenu',
    'loSiteSettings.language.hint': 'Rédigez dans cette langue. À la publication, l’IA peut traduire pour vos visiteurs.',
    'loSiteSettings.analytics.title': 'Mesure d’audience',
    'loSiteSettings.analytics.desc': 'Connectez Google Analytics ou Plausible pour suivre les visites.',
    'loSiteSettings.analytics.ga': 'Google Analytics (ID G-)',
    'loSiteSettings.analytics.plausible': 'Plausible (domaine)',
    'loSiteSettings.domain.title': 'Domaine personnalisé',
    'loSiteSettings.domain.desc': 'Plan Expert — pointez votre DNS vers LyrraOne (une config plateforme).',
    'loSiteSettings.domain.label': 'Nom de domaine',
    'loSiteSettings.domain.configure': 'Configurer',
    'loSiteSettings.domain.verified': 'Domaine vérifié — marque blanche active',
    'loSiteSettings.domain.pending': 'En attente de vérification DNS',
    'loSiteSettings.domain.dnsTitle': 'Configuration DNS',
    'loSiteSettings.domain.dnsStableHint': 'Domaine déjà vérifié : ces valeurs TXT/CNAME restent stables. Ne cliquez sur Configurer qu’en cas de changement de domaine.',
    'loSiteSettings.domain.host': 'Hôte',
    'loSiteSettings.domain.value': 'Valeur',
    'loSiteSettings.domain.txtLabel': 'TXT (vérification)',
    'loSiteSettings.domain.cnameLabel': 'CNAME (routage)',
    'loSiteSettings.domain.verify': 'Vérifier le DNS',
    'loSiteSettings.domain.legalRequired': 'Documents légaux à valider avant vérification.',
    'loSiteSettings.domain.legalToast': 'Validez d’abord vos CGV, confidentialité et cookies.',
    'loSiteSettings.domain.upgradeTitle': 'Domaine & marque blanche',
    'loSiteSettings.domain.upgradeDesc': 'Réservé au plan Expert : votre domaine, logo et favicon, sans crédit LyrraOne.',
    'loSiteSettings.ssl.title': 'Certificat HTTPS',
    'loSiteSettings.ssl.desc': 'Sécurisez votre domaine sans ligne de commande : Let\'s Encrypt automatique, ou importez votre propre certificat.',
    'loSiteSettings.ssl.modeLabel': 'Mode SSL',
    'loSiteSettings.ssl.modeLe': 'Let\'s Encrypt (recommandé)',
    'loSiteSettings.ssl.modeLeDesc': 'Certificat gratuit généré et renouvelé automatiquement.',
    'loSiteSettings.ssl.modeCustom': 'Certificat personnel',
    'loSiteSettings.ssl.modeCustomDesc': 'Collez votre certificat et votre clé privée (PEM).',
    'loSiteSettings.ssl.activateLe': 'Activer HTTPS (Let\'s Encrypt)',
    'loSiteSettings.ssl.refresh': 'Vérifier le certificat',
    'loSiteSettings.ssl.statusActive': 'HTTPS actif',
    'loSiteSettings.ssl.statusPending': 'Activation en cours…',
    'loSiteSettings.ssl.statusError': 'HTTPS non actif',
    'loSiteSettings.ssl.statusNone': 'Aucun certificat détecté',
    'loSiteSettings.ssl.statusUnknown': 'Statut SSL inconnu',
    'loSiteSettings.ssl.issuer': 'Émetteur',
    'loSiteSettings.ssl.expires': 'Expire le',
    'loSiteSettings.ssl.leSuccess': 'Certificat Let\'s Encrypt actif.',
    'loSiteSettings.ssl.lePending': 'Émission en cours ou DNS/Caddy incomplet — réessayez dans une minute.',
    'loSiteSettings.ssl.leFail': 'Impossible d\'activer Let\'s Encrypt.',
    'loSiteSettings.ssl.refreshOk': 'Statut SSL actualisé.',
    'loSiteSettings.ssl.refreshFail': 'Vérification SSL impossible.',
    'loSiteSettings.ssl.certLabel': 'Certificat (PEM)',
    'loSiteSettings.ssl.keyLabel': 'Clé privée (PEM)',
    'loSiteSettings.ssl.chainLabel': 'Chaîne intermédiaire (optionnel)',
    'loSiteSettings.ssl.chainPlaceholder': '-----BEGIN CERTIFICATE----- (optionnel)',
    'loSiteSettings.ssl.upload': 'Installer mon certificat',
    'loSiteSettings.ssl.removeCustom': 'Retirer le certificat perso',
    'loSiteSettings.ssl.customRequired': 'Certificat et clé privée requis.',
    'loSiteSettings.ssl.customSuccess': 'Certificat personnel installé.',
    'loSiteSettings.ssl.customPending': 'Certificat enregistré — HTTPS pas encore confirmé.',
    'loSiteSettings.ssl.customFail': 'Impossible d\'installer le certificat.',
    'loSiteSettings.ssl.customRemoved': 'Certificat personnel retiré — vous pouvez activer Let\'s Encrypt.',
    'loSiteSettings.ssl.customRemoveFail': 'Impossible de retirer le certificat.',
    'loSiteSettings.ssl.customProvisioningHint': 'L\'upload est accepté. Sur cette instance, le chargement automatique vers le reverse-proxy peut nécessiter une config plateforme (Caddy Admin).',
    'loSiteSettings.googleOAuth.title': 'Connexion Google (marque blanche)',
    'loSiteSettings.googleOAuth.desc': 'Utilisez votre propre application Google Cloud pour que l’écran de connexion affiche votre marque — pas LyrraOne. Sans configuration, le bouton Google est masqué sur votre domaine.',
    'loSiteSettings.googleOAuth.active': 'Google activé sur votre site',
    'loSiteSettings.googleOAuth.inactive': 'Non configuré — bouton masqué',
    'loSiteSettings.googleOAuth.loading': 'Chargement…',
    'loSiteSettings.googleOAuth.howto': 'Créez un client OAuth « Application Web » dans Google Cloud Console, choisissez le nom affiché sur l’écran de consentement, puis collez l’URI de redirection ci-dessous (sur votre domaine) dans Authorized redirect URIs.',
    'loSiteSettings.googleOAuth.redirectUri': 'URI de redirection à autoriser',
    'loSiteSettings.googleOAuth.redirectHint': 'Sur votre domaine personnalisé — Google redirige vers votre site (proxifié vers LyrraOne). Ajoutez aussi votre domaine dans « Domaines autorisés » de l’écran de consentement.',
    'loSiteSettings.googleOAuth.copy': 'Copier l’URI',
    'loSiteSettings.googleOAuth.clientId': 'Client ID',
    'loSiteSettings.googleOAuth.clientSecret': 'Client secret',
    'loSiteSettings.googleOAuth.secretPlaceholder': 'Coller le secret Google',
    'loSiteSettings.googleOAuth.secretPlaceholderKeep': 'Laisser vide pour conserver le secret actuel',
    'loSiteSettings.googleOAuth.secretConfigured': 'Un secret est déjà enregistré (chiffré).',
    'loSiteSettings.googleOAuth.clientIdRequired': 'Client ID requis.',
    'loSiteSettings.googleOAuth.secretRequired': 'Client secret requis à la première configuration.',
    'loSiteSettings.googleOAuth.save': 'Enregistrer Google OAuth',
    'loSiteSettings.googleOAuth.clear': 'Désactiver Google',
    'loSiteSettings.googleOAuth.saved': 'Connexion Google enregistrée.',
    'loSiteSettings.googleOAuth.saveFail': 'Impossible d’enregistrer Google OAuth.',
    'loSiteSettings.googleOAuth.cleared': 'Connexion Google désactivée sur votre site.',
    'loSiteSettings.googleOAuth.clearFail': 'Impossible de désactiver Google OAuth.',
    'loSiteSettings.legal.title': 'Pages légales',
    'loSiteSettings.legal.desc': 'Obligatoire avec un domaine personnalisé : CGV, confidentialité et cookies.',
    'loSiteSettings.branding.title': 'Marque blanche',
    'loSiteSettings.branding.descReady': 'Votre site s’affiche sous votre identité : logo, favicon, sans crédit LyrraOne.',
    'loSiteSettings.branding.descLocked': 'Disponible dès que votre domaine personnalisé est vérifié.',
    'loSiteSettings.branding.logo': 'Logo du site (en-tête)',
    'loSiteSettings.branding.logoHint': 'Affiché dans la navigation à la place du nom. PNG ou SVG, fond transparent.',
    'loSiteSettings.branding.favicon': 'Favicon (onglet navigateur)',
    'loSiteSettings.branding.faviconHint': 'Si vide, le logo est utilisé. Sinon icône carrée 32×32 ou 64×64.',
    'loSiteSettings.branding.poweredBy': 'Le crédit « Propulsé par LyrraOne » est masqué tant que le domaine reste actif.',
    'loSiteSettings.branding.lockedHint': 'Vérifiez d’abord le domaine pour débloquer logo, favicon et retrait de la marque.',
    'loSiteSettings.features.title': 'Options & référencement',
    'loSiteSettings.features.desc': 'Blog dans le menu et URL utiles pour les moteurs de recherche.',
    'loSiteSettings.features.blog': 'Blog dans la navigation',
    'loSiteSettings.features.blogDesc': 'Affiche le lien vers votre blog dans le menu du site public.',
    'loSiteSettings.features.sitemap': 'Sitemap XML',
    'loSiteSettings.features.sitemapCustomHint': 'URL de votre domaine personnalisé — à soumettre dans Google Search Console.',
    'loSiteSettings.payments.title': 'Encaissement des ventes',
    'loSiteSettings.payments.desc': 'LyrraPay ou Stripe Connect selon votre plan.',
    'loSiteSettings.payments.hint': 'Configurez comment vous encaissez les ventes (formations, packs, funnels).',
    'loSiteSettings.payments.link': 'Ouvrir la page Encaissement & Stripe',
    'loSiteSettings.help.identity.title': 'Identité du site',
    'loSiteSettings.help.identity.p1': 'Le nom du site apparaît dans l’en-tête public, le pied de page et les balises SEO.',
    'loSiteSettings.help.identity.p2': 'L’identifiant /s/votre-slug est généré automatiquement. Vos visiteurs peuvent aussi utiliser votre domaine personnalisé une fois vérifié.',
    'loSiteSettings.help.identity.s1': 'Choisissez un nom clair (marque ou offre).',
    'loSiteSettings.help.identity.s2': 'Quittez le champ pour enregistrer le nom immédiatement.',
    'loSiteSettings.help.identity.s3': 'Ouvrez /s/… pour prévisualiser le rendu public.',
    'loSiteSettings.help.language.title': 'Langue de rédaction',
    'loSiteSettings.help.language.p1': 'Cette langue est la source de vos contenus. Les traductions publiques partent de ce texte.',
    'loSiteSettings.help.language.p2': 'Changez-la avant une grosse campagne de contenu pour éviter de retraduire trop souvent.',
    'loSiteSettings.help.language.s1': 'Sélectionnez la langue dans laquelle vous rédigez.',
    'loSiteSettings.help.language.s2': 'Enregistrez les paramètres.',
    'loSiteSettings.help.language.s3': 'Publiez vos pages : les autres langues suivent selon votre workflow.',
    'loSiteSettings.help.analytics.title': 'Mesure d’audience',
    'loSiteSettings.help.analytics.p1': 'Google Analytics (ID G-) ou Plausible (domaine) mesurent le trafic de votre site public.',
    'loSiteSettings.help.analytics.p2': 'Respectez le consentement cookies : les tags non essentiels restent bloqués tant que le visiteur n’a pas accepté.',
    'loSiteSettings.help.analytics.s1': 'Créez une propriété GA4 ou un site Plausible.',
    'loSiteSettings.help.analytics.s2': 'Collez l’ID G- ou le domaine ici.',
    'loSiteSettings.help.analytics.s3': 'Enregistrez puis vérifiez une visite de test.',
    'loSiteSettings.help.domain.title': 'Domaine personnalisé',
    'loSiteSettings.help.domain.p1': 'Avec le plan Expert, votre site est accessible sur votre nom de domaine (marque blanche).',
    'loSiteSettings.help.domain.p2': 'Ajoutez les enregistrements TXT (preuve) et CNAME (routage) chez votre registrar, puis vérifiez. Ensuite activez HTTPS (Let\'s Encrypt ou certificat perso).',
    'loSiteSettings.help.domain.s1': 'Saisissez www.votredomaine.fr (ou un sous-domaine).',
    'loSiteSettings.help.domain.s2': 'Cliquez sur Configurer et copiez les DNS.',
    'loSiteSettings.help.domain.s3': 'Validez les pages légales, Vérifier le DNS, puis Activer HTTPS.',
    'loSiteSettings.help.legal.title': 'Pages légales',
    'loSiteSettings.help.legal.p1': 'Un domaine à votre nom implique vos propres CGV, confidentialité et cookies.',
    'loSiteSettings.help.legal.p2': 'LyrraOne propose un modèle : adaptez-le à votre activité, puis validez chaque document. Une modification annule la validation.',
    'loSiteSettings.help.legal.s1': 'Ouvrez chaque onglet (CGV, confidentialité, cookies).',
    'loSiteSettings.help.legal.s2': 'Adaptez le texte ou réinitialisez le modèle.',
    'loSiteSettings.help.legal.s3': 'Cliquez sur « J’ai relu et je valide », puis Enregistrer.',
    'loSiteSettings.help.branding.title': 'Marque blanche',
    'loSiteSettings.help.branding.p1': 'Une fois le domaine vérifié, logo et favicon remplacent l’identité LyrraOne sur votre site.',
    'loSiteSettings.help.branding.p2': 'Le crédit « Propulsé par LyrraOne » est masqué automatiquement.',
    'loSiteSettings.help.branding.s1': 'Vérifiez le domaine (onglet Domaine).',
    'loSiteSettings.help.branding.s2': 'Importez un logo transparent (PNG/SVG).',
    'loSiteSettings.help.branding.s3': 'Ajoutez un favicon carré si besoin, puis Enregistrer.',
    'loSiteSettings.help.features.title': 'Options & SEO',
    'loSiteSettings.help.features.p1': 'Activez le blog dans le menu et partagez le sitemap avec Google Search Console.',
    'loSiteSettings.help.features.p2': 'Sans domaine perso : URL /api/public/…/sitemap.xml. Avec domaine vérifié : https://votredomaine/sitemap.xml (liens du site sans /s/…).',
    'loSiteSettings.help.features.s1': 'Activez ou masquez le blog dans la navigation.',
    'loSiteSettings.help.features.s2': 'Copiez l’URL sitemap affichée.',
    'loSiteSettings.help.features.s3': 'Soumettez-la dans votre outil SEO.',
    'loSiteSettings.help.payments.title': 'Encaissement',
    'loSiteSettings.help.payments.p1': 'Les paiements des formations et packs passent par LyrraPay ou Stripe Connect selon votre plan.',
    'loSiteSettings.help.payments.p2': 'Vous pouvez aussi ouvrir la page Encaissement dédiée pour le détail Stripe.',
    'loSiteSettings.help.payments.s1': 'Choisissez le mode d’encaissement proposé.',
    'loSiteSettings.help.payments.s2': 'Complétez la connexion Stripe si demandé.',
    'loSiteSettings.help.payments.s3': 'Testez un achat sur une offre en brouillon / test.',
  },
  en: {
    'loSiteSettings.back': '← Settings',
    'loSiteSettings.pageTitle': 'Site settings',
    'loSiteSettings.pageSubtitle': 'Identity, domain, white label, analytics and public site options.',
    'loSiteSettings.themeCallout': 'Visual theme is edited in the page editor (<link>{{name}}</link>), Theme tab.',
    'loSiteSettings.themeLink': 'Website',
    'loSiteSettings.save': 'Save settings',
    'loSiteSettings.saving': 'Saving…',
    'loSiteSettings.copied': 'Copied to clipboard',
    'loSiteSettings.copyFail': 'Could not copy',
    'loSiteSettings.help.openAria': 'Show help for {{tab}}',
    'loSiteSettings.help.closeAria': 'Close help panel',
    'loSiteSettings.help.title': 'Help',
    'loSiteSettings.help.keepOpen': 'Keep open',
    'loSiteSettings.help.empty': 'Click the ? icon on a tab to show help here, next to the form.',
    'loSiteSettings.help.steps': 'Steps',
    'loSiteSettings.tabs.identity': 'Identity',
    'loSiteSettings.tabs.language': 'Language',
    'loSiteSettings.tabs.analytics': 'Analytics',
    'loSiteSettings.tabs.domain': 'Domain',
    'loSiteSettings.tabs.legal': 'Legal',
    'loSiteSettings.tabs.branding': 'White label',
    'loSiteSettings.tabs.features': 'Options',
    'loSiteSettings.tabs.payments': 'Payments',
    'loSiteSettings.identity.title': 'Site identity',
    'loSiteSettings.identity.desc': 'Name shown in the header, footer and metadata.',
    'loSiteSettings.identity.name': 'Site name',
    'loSiteSettings.identity.placeholder': 'My training site',
    'loSiteSettings.identity.saving': 'Saving name…',
    'loSiteSettings.identity.dirty': 'Name changed — saved on blur or via Save.',
    'loSiteSettings.identity.slug': 'Public ID:',
    'loSiteSettings.language.title': 'Writing language',
    'loSiteSettings.language.desc': 'Source language for writing and auto-translation on publish.',
    'loSiteSettings.language.label': 'Main content language',
    'loSiteSettings.language.hint': 'Write in this language. On publish, AI can translate for visitors.',
    'loSiteSettings.analytics.title': 'Audience measurement',
    'loSiteSettings.analytics.desc': 'Connect Google Analytics or Plausible to track visits.',
    'loSiteSettings.analytics.ga': 'Google Analytics (G- ID)',
    'loSiteSettings.analytics.plausible': 'Plausible (domain)',
    'loSiteSettings.domain.title': 'Custom domain',
    'loSiteSettings.domain.desc': 'Expert plan — point your DNS to LyrraOne (one platform config).',
    'loSiteSettings.domain.label': 'Domain name',
    'loSiteSettings.domain.configure': 'Configure',
    'loSiteSettings.domain.verified': 'Domain verified — white label active',
    'loSiteSettings.domain.pending': 'Waiting for DNS verification',
    'loSiteSettings.domain.dnsTitle': 'DNS setup',
    'loSiteSettings.domain.dnsStableHint': 'Domain already verified: these TXT/CNAME values stay stable. Only click Configure if you change the domain.',
    'loSiteSettings.domain.host': 'Host',
    'loSiteSettings.domain.value': 'Value',
    'loSiteSettings.domain.txtLabel': 'TXT (verification)',
    'loSiteSettings.domain.cnameLabel': 'CNAME (routing)',
    'loSiteSettings.domain.verify': 'Verify DNS',
    'loSiteSettings.domain.legalRequired': 'Validate legal pages before verification.',
    'loSiteSettings.domain.legalToast': 'Please validate your terms, privacy and cookies first.',
    'loSiteSettings.domain.upgradeTitle': 'Domain & white label',
    'loSiteSettings.domain.upgradeDesc': 'Expert plan only: your domain, logo and favicon, without LyrraOne credit.',
    'loSiteSettings.ssl.title': 'HTTPS certificate',
    'loSiteSettings.ssl.desc': 'Secure your domain with no command line: automatic Let\'s Encrypt, or upload your own certificate.',
    'loSiteSettings.ssl.modeLabel': 'SSL mode',
    'loSiteSettings.ssl.modeLe': 'Let\'s Encrypt (recommended)',
    'loSiteSettings.ssl.modeLeDesc': 'Free certificate issued and renewed automatically.',
    'loSiteSettings.ssl.modeCustom': 'Your own certificate',
    'loSiteSettings.ssl.modeCustomDesc': 'Paste your certificate and private key (PEM).',
    'loSiteSettings.ssl.activateLe': 'Enable HTTPS (Let\'s Encrypt)',
    'loSiteSettings.ssl.refresh': 'Check certificate',
    'loSiteSettings.ssl.statusActive': 'HTTPS active',
    'loSiteSettings.ssl.statusPending': 'Activation in progress…',
    'loSiteSettings.ssl.statusError': 'HTTPS not active',
    'loSiteSettings.ssl.statusNone': 'No certificate detected',
    'loSiteSettings.ssl.statusUnknown': 'Unknown SSL status',
    'loSiteSettings.ssl.issuer': 'Issuer',
    'loSiteSettings.ssl.expires': 'Expires',
    'loSiteSettings.ssl.leSuccess': 'Let\'s Encrypt certificate is active.',
    'loSiteSettings.ssl.lePending': 'Issuance pending or DNS/Caddy incomplete — try again in a minute.',
    'loSiteSettings.ssl.leFail': 'Could not enable Let\'s Encrypt.',
    'loSiteSettings.ssl.refreshOk': 'SSL status refreshed.',
    'loSiteSettings.ssl.refreshFail': 'SSL check failed.',
    'loSiteSettings.ssl.certLabel': 'Certificate (PEM)',
    'loSiteSettings.ssl.keyLabel': 'Private key (PEM)',
    'loSiteSettings.ssl.chainLabel': 'Intermediate chain (optional)',
    'loSiteSettings.ssl.chainPlaceholder': '-----BEGIN CERTIFICATE----- (optional)',
    'loSiteSettings.ssl.upload': 'Install my certificate',
    'loSiteSettings.ssl.removeCustom': 'Remove custom certificate',
    'loSiteSettings.ssl.customRequired': 'Certificate and private key are required.',
    'loSiteSettings.ssl.customSuccess': 'Custom certificate installed.',
    'loSiteSettings.ssl.customPending': 'Certificate saved — HTTPS not confirmed yet.',
    'loSiteSettings.ssl.customFail': 'Could not install the certificate.',
    'loSiteSettings.ssl.customRemoved': 'Custom certificate removed — you can enable Let\'s Encrypt.',
    'loSiteSettings.ssl.customRemoveFail': 'Could not remove the certificate.',
    'loSiteSettings.ssl.customProvisioningHint': 'Upload is accepted. On this instance, automatic loading into the reverse proxy may need platform config (Caddy Admin).',
    'loSiteSettings.googleOAuth.title': 'Google sign-in (white label)',
    'loSiteSettings.googleOAuth.desc': 'Use your own Google Cloud OAuth app so the consent screen shows your brand — not LyrraOne. If unset, the Google button is hidden on your domain.',
    'loSiteSettings.googleOAuth.active': 'Google enabled on your site',
    'loSiteSettings.googleOAuth.inactive': 'Not configured — button hidden',
    'loSiteSettings.googleOAuth.loading': 'Loading…',
    'loSiteSettings.googleOAuth.howto': 'Create a Web application OAuth client in Google Cloud Console, set the consent screen name to your brand, then paste the redirect URI below (on your domain) into Authorized redirect URIs.',
    'loSiteSettings.googleOAuth.redirectUri': 'Authorized redirect URI',
    'loSiteSettings.googleOAuth.redirectHint': 'On your custom domain — Google redirects to your site (proxied to LyrraOne). Also add your domain under Authorized domains on the consent screen.',
    'loSiteSettings.googleOAuth.copy': 'Copy URI',
    'loSiteSettings.googleOAuth.clientId': 'Client ID',
    'loSiteSettings.googleOAuth.clientSecret': 'Client secret',
    'loSiteSettings.googleOAuth.secretPlaceholder': 'Paste Google secret',
    'loSiteSettings.googleOAuth.secretPlaceholderKeep': 'Leave blank to keep the current secret',
    'loSiteSettings.googleOAuth.secretConfigured': 'A secret is already stored (encrypted).',
    'loSiteSettings.googleOAuth.clientIdRequired': 'Client ID is required.',
    'loSiteSettings.googleOAuth.secretRequired': 'Client secret is required for the first setup.',
    'loSiteSettings.googleOAuth.save': 'Save Google OAuth',
    'loSiteSettings.googleOAuth.clear': 'Disable Google',
    'loSiteSettings.googleOAuth.saved': 'Google sign-in saved.',
    'loSiteSettings.googleOAuth.saveFail': 'Could not save Google OAuth.',
    'loSiteSettings.googleOAuth.cleared': 'Google sign-in disabled on your site.',
    'loSiteSettings.googleOAuth.clearFail': 'Could not disable Google OAuth.',
    'loSiteSettings.legal.title': 'Legal pages',
    'loSiteSettings.legal.desc': 'Required with a custom domain: terms, privacy and cookies.',
    'loSiteSettings.branding.title': 'White label',
    'loSiteSettings.branding.descReady': 'Your site shows your identity: logo, favicon, no LyrraOne credit.',
    'loSiteSettings.branding.descLocked': 'Available once your custom domain is verified.',
    'loSiteSettings.branding.logo': 'Site logo (header)',
    'loSiteSettings.branding.logoHint': 'Shown in navigation instead of the name. PNG or SVG, transparent background.',
    'loSiteSettings.branding.favicon': 'Favicon (browser tab)',
    'loSiteSettings.branding.faviconHint': 'If empty, the logo is used. Otherwise a square 32×32 or 64×64 icon.',
    'loSiteSettings.branding.poweredBy': '“Powered by LyrraOne” is hidden while the domain stays active.',
    'loSiteSettings.branding.lockedHint': 'Verify the domain first to unlock logo, favicon and brand removal.',
    'loSiteSettings.features.title': 'Options & SEO',
    'loSiteSettings.features.desc': 'Blog in the menu and useful URLs for search engines.',
    'loSiteSettings.features.blog': 'Blog in navigation',
    'loSiteSettings.features.blogDesc': 'Shows the blog link in the public site menu.',
    'loSiteSettings.features.sitemap': 'XML sitemap',
    'loSiteSettings.features.sitemapCustomHint': 'Your custom domain URL — submit it in Google Search Console.',
    'loSiteSettings.payments.title': 'Payment collection',
    'loSiteSettings.payments.desc': 'LyrraPay or Stripe Connect depending on your plan.',
    'loSiteSettings.payments.hint': 'Configure how you collect payments (courses, packs, funnels).',
    'loSiteSettings.payments.link': 'Open Payments & Stripe page',
    'loSiteSettings.help.identity.title': 'Site identity',
    'loSiteSettings.help.identity.p1': 'The site name appears in the public header, footer and SEO tags.',
    'loSiteSettings.help.identity.p2': 'The /s/your-slug ID is generated automatically. Visitors can also use your custom domain once verified.',
    'loSiteSettings.help.identity.s1': 'Pick a clear name (brand or offer).',
    'loSiteSettings.help.identity.s2': 'Leave the field to save the name immediately.',
    'loSiteSettings.help.identity.s3': 'Open /s/… to preview the public site.',
    'loSiteSettings.help.language.title': 'Writing language',
    'loSiteSettings.help.language.p1': 'This is the source language of your content. Public translations start from this text.',
    'loSiteSettings.help.language.p2': 'Change it before a large content campaign to avoid retranslating often.',
    'loSiteSettings.help.language.s1': 'Select the language you write in.',
    'loSiteSettings.help.language.s2': 'Save settings.',
    'loSiteSettings.help.language.s3': 'Publish pages; other languages follow your workflow.',
    'loSiteSettings.help.analytics.title': 'Audience measurement',
    'loSiteSettings.help.analytics.p1': 'Google Analytics (G- ID) or Plausible (domain) track traffic on your public site.',
    'loSiteSettings.help.analytics.p2': 'Respect cookie consent: non-essential tags stay blocked until the visitor accepts.',
    'loSiteSettings.help.analytics.s1': 'Create a GA4 property or Plausible site.',
    'loSiteSettings.help.analytics.s2': 'Paste the G- ID or domain here.',
    'loSiteSettings.help.analytics.s3': 'Save, then check a test visit.',
    'loSiteSettings.help.domain.title': 'Custom domain',
    'loSiteSettings.help.domain.p1': 'With Expert, your site is available on your own domain (white label).',
    'loSiteSettings.help.domain.p2': 'Add TXT (proof) and CNAME (routing) records at your registrar, then verify. Then enable HTTPS (Let\'s Encrypt or your own certificate).',
    'loSiteSettings.help.domain.s1': 'Enter www.yourdomain.com (or a subdomain).',
    'loSiteSettings.help.domain.s2': 'Click Configure and copy the DNS records.',
    'loSiteSettings.help.domain.s3': 'Validate legal pages, Verify DNS, then Enable HTTPS.',
    'loSiteSettings.help.legal.title': 'Legal pages',
    'loSiteSettings.help.legal.p1': 'Using your own domain means publishing your own terms, privacy and cookies pages.',
    'loSiteSettings.help.legal.p2': 'LyrraOne provides a template: adapt it, then validate each document. Editing clears validation.',
    'loSiteSettings.help.legal.s1': 'Open each document (terms, privacy, cookies).',
    'loSiteSettings.help.legal.s2': 'Edit the text or reset the template.',
    'loSiteSettings.help.legal.s3': 'Click “I have reviewed and I validate”, then Save.',
    'loSiteSettings.help.branding.title': 'White label',
    'loSiteSettings.help.branding.p1': 'Once the domain is verified, logo and favicon replace LyrraOne branding.',
    'loSiteSettings.help.branding.p2': '“Powered by LyrraOne” is hidden automatically.',
    'loSiteSettings.help.branding.s1': 'Verify the domain (Domain tab).',
    'loSiteSettings.help.branding.s2': 'Upload a transparent logo (PNG/SVG).',
    'loSiteSettings.help.branding.s3': 'Add a square favicon if needed, then Save.',
    'loSiteSettings.help.features.title': 'Options & SEO',
    'loSiteSettings.help.features.p1': 'Enable the blog in the menu and share the sitemap with Google Search Console.',
    'loSiteSettings.help.features.p2': 'Without a custom domain: /api/public/…/sitemap.xml. With a verified domain: https://yourdomain/sitemap.xml (site links without /s/…).',
    'loSiteSettings.help.features.s1': 'Show or hide the blog in navigation.',
    'loSiteSettings.help.features.s2': 'Copy the sitemap URL shown.',
    'loSiteSettings.help.features.s3': 'Submit it in your SEO tool.',
    'loSiteSettings.help.payments.title': 'Payments',
    'loSiteSettings.help.payments.p1': 'Course and pack payments go through LyrraPay or Stripe Connect depending on your plan.',
    'loSiteSettings.help.payments.p2': 'You can also open the dedicated Payments page for Stripe details.',
    'loSiteSettings.help.payments.s1': 'Choose the offered collection mode.',
    'loSiteSettings.help.payments.s2': 'Complete Stripe Connect if required.',
    'loSiteSettings.help.payments.s3': 'Test a purchase on a draft/test offer.',
  },
  // Other languages: start from EN then override (full copies for i18n merge)
  es: {},
  de: {},
  it: {},
  pt: {},
  lb: {},
  uk: {},
  ru: {},
  ar: {},
  tr: {},
  zgh: {},
};

// Remplir les locales non-FR/EN à partir de l’anglais, puis surcharges natives essentielles.
const EN = loSiteSettingsLocales.en;

function fillFromEn(overrides: Record<string, string>): Record<string, string> {
  return { ...EN, ...overrides };
}

loSiteSettingsLocales.es = fillFromEn({
  'loSiteSettings.pageTitle': 'Ajustes del sitio',
  'loSiteSettings.pageSubtitle': 'Identidad, dominio, marca blanca, audiencia y opciones del sitio público.',
  'loSiteSettings.save': 'Guardar ajustes',
  'loSiteSettings.saving': 'Guardando…',
  'loSiteSettings.help.title': 'Ayuda',
  'loSiteSettings.help.keepOpen': 'Mantener abierto',
  'loSiteSettings.tabs.identity': 'Identidad',
  'loSiteSettings.tabs.language': 'Idioma',
  'loSiteSettings.tabs.analytics': 'Audiencia',
  'loSiteSettings.tabs.domain': 'Dominio',
  'loSiteSettings.tabs.legal': 'Legal',
  'loSiteSettings.tabs.branding': 'Marca blanca',
  'loSiteSettings.tabs.features': 'Opciones',
  'loSiteSettings.tabs.payments': 'Pagos',
  'loSiteSettings.themeLink': 'Sitio web',
  'loSiteSettings.domain.configure': 'Configurar',
  'loSiteSettings.domain.verify': 'Verificar DNS',
});

loSiteSettingsLocales.de = fillFromEn({
  'loSiteSettings.pageTitle': 'Website-Einstellungen',
  'loSiteSettings.pageSubtitle': 'Identität, Domain, White-Label, Analytics und öffentliche Optionen.',
  'loSiteSettings.save': 'Einstellungen speichern',
  'loSiteSettings.saving': 'Speichern…',
  'loSiteSettings.help.title': 'Hilfe',
  'loSiteSettings.help.keepOpen': 'Offen halten',
  'loSiteSettings.tabs.identity': 'Identität',
  'loSiteSettings.tabs.language': 'Sprache',
  'loSiteSettings.tabs.analytics': 'Analytics',
  'loSiteSettings.tabs.domain': 'Domain',
  'loSiteSettings.tabs.legal': 'Rechtliches',
  'loSiteSettings.tabs.branding': 'White-Label',
  'loSiteSettings.tabs.features': 'Optionen',
  'loSiteSettings.tabs.payments': 'Zahlungen',
  'loSiteSettings.themeLink': 'Website',
  'loSiteSettings.domain.configure': 'Einrichten',
  'loSiteSettings.domain.verify': 'DNS prüfen',
});

loSiteSettingsLocales.it = fillFromEn({
  'loSiteSettings.pageTitle': 'Impostazioni del sito',
  'loSiteSettings.pageSubtitle': 'Identità, dominio, white label, analytics e opzioni del sito pubblico.',
  'loSiteSettings.save': 'Salva impostazioni',
  'loSiteSettings.saving': 'Salvataggio…',
  'loSiteSettings.help.title': 'Aiuto',
  'loSiteSettings.help.keepOpen': 'Mantieni aperto',
  'loSiteSettings.tabs.identity': 'Identità',
  'loSiteSettings.tabs.language': 'Lingua',
  'loSiteSettings.tabs.analytics': 'Audience',
  'loSiteSettings.tabs.domain': 'Dominio',
  'loSiteSettings.tabs.legal': 'Legale',
  'loSiteSettings.tabs.branding': 'White label',
  'loSiteSettings.tabs.features': 'Opzioni',
  'loSiteSettings.tabs.payments': 'Pagamenti',
  'loSiteSettings.themeLink': 'Sito web',
  'loSiteSettings.domain.configure': 'Configura',
  'loSiteSettings.domain.verify': 'Verifica DNS',
});

loSiteSettingsLocales.pt = fillFromEn({
  'loSiteSettings.pageTitle': 'Definições do site',
  'loSiteSettings.pageSubtitle': 'Identidade, domínio, marca branca, audiência e opções do site público.',
  'loSiteSettings.save': 'Guardar definições',
  'loSiteSettings.saving': 'A guardar…',
  'loSiteSettings.help.title': 'Ajuda',
  'loSiteSettings.help.keepOpen': 'Manter aberto',
  'loSiteSettings.tabs.identity': 'Identidade',
  'loSiteSettings.tabs.language': 'Idioma',
  'loSiteSettings.tabs.analytics': 'Audiência',
  'loSiteSettings.tabs.domain': 'Domínio',
  'loSiteSettings.tabs.legal': 'Legal',
  'loSiteSettings.tabs.branding': 'Marca branca',
  'loSiteSettings.tabs.features': 'Opções',
  'loSiteSettings.tabs.payments': 'Pagamentos',
  'loSiteSettings.themeLink': 'Site',
  'loSiteSettings.domain.configure': 'Configurar',
  'loSiteSettings.domain.verify': 'Verificar DNS',
});

loSiteSettingsLocales.lb = fillFromEn({
  'loSiteSettings.pageTitle': 'Site-Astellungen',
  'loSiteSettings.save': 'Astellungen späicheren',
  'loSiteSettings.help.title': 'Hëllef',
  'loSiteSettings.tabs.identity': 'Identitéit',
  'loSiteSettings.tabs.language': 'Sprooch',
  'loSiteSettings.tabs.domain': 'Domain',
  'loSiteSettings.tabs.legal': 'Legal',
  'loSiteSettings.tabs.branding': 'White Label',
  'loSiteSettings.tabs.features': 'Optiounen',
  'loSiteSettings.tabs.payments': 'Bezuelungen',
});

loSiteSettingsLocales.uk = fillFromEn({
  'loSiteSettings.pageTitle': 'Налаштування сайту',
  'loSiteSettings.save': 'Зберегти налаштування',
  'loSiteSettings.help.title': 'Довідка',
  'loSiteSettings.help.keepOpen': 'Тримати відкритим',
  'loSiteSettings.tabs.identity': 'Ідентичність',
  'loSiteSettings.tabs.language': 'Мова',
  'loSiteSettings.tabs.analytics': 'Аналітика',
  'loSiteSettings.tabs.domain': 'Домен',
  'loSiteSettings.tabs.legal': 'Юридичне',
  'loSiteSettings.tabs.branding': 'White label',
  'loSiteSettings.tabs.features': 'Опції',
  'loSiteSettings.tabs.payments': 'Оплата',
  'loSiteSettings.domain.configure': 'Налаштувати',
  'loSiteSettings.domain.verify': 'Перевірити DNS',
});

loSiteSettingsLocales.ru = fillFromEn({
  'loSiteSettings.pageTitle': 'Настройки сайта',
  'loSiteSettings.save': 'Сохранить настройки',
  'loSiteSettings.help.title': 'Справка',
  'loSiteSettings.help.keepOpen': 'Держать открытым',
  'loSiteSettings.tabs.identity': 'Идентичность',
  'loSiteSettings.tabs.language': 'Язык',
  'loSiteSettings.tabs.analytics': 'Аналитика',
  'loSiteSettings.tabs.domain': 'Домен',
  'loSiteSettings.tabs.legal': 'Юридическое',
  'loSiteSettings.tabs.branding': 'White label',
  'loSiteSettings.tabs.features': 'Опции',
  'loSiteSettings.tabs.payments': 'Оплата',
  'loSiteSettings.domain.configure': 'Настроить',
  'loSiteSettings.domain.verify': 'Проверить DNS',
});

loSiteSettingsLocales.ar = fillFromEn({
  'loSiteSettings.pageTitle': 'إعدادات الموقع',
  'loSiteSettings.pageSubtitle': 'الهوية والنطاق والعلامة البيضاء والتحليلات وخيارات الموقع العام.',
  'loSiteSettings.save': 'حفظ الإعدادات',
  'loSiteSettings.saving': 'جاري الحفظ…',
  'loSiteSettings.help.title': 'مساعدة',
  'loSiteSettings.help.keepOpen': 'إبقاء مفتوحًا',
  'loSiteSettings.tabs.identity': 'الهوية',
  'loSiteSettings.tabs.language': 'اللغة',
  'loSiteSettings.tabs.analytics': 'الجمهور',
  'loSiteSettings.tabs.domain': 'النطاق',
  'loSiteSettings.tabs.legal': 'قانوني',
  'loSiteSettings.tabs.branding': 'علامة بيضاء',
  'loSiteSettings.tabs.features': 'خيارات',
  'loSiteSettings.tabs.payments': 'المدفوعات',
  'loSiteSettings.domain.configure': 'تهيئة',
  'loSiteSettings.domain.verify': 'التحقق من DNS',
});

loSiteSettingsLocales.tr = fillFromEn({
  'loSiteSettings.pageTitle': 'Site ayarları',
  'loSiteSettings.pageSubtitle': 'Kimlik, alan adı, beyaz etiket, analitik ve genel site seçenekleri.',
  'loSiteSettings.save': 'Ayarları kaydet',
  'loSiteSettings.saving': 'Kaydediliyor…',
  'loSiteSettings.help.title': 'Yardım',
  'loSiteSettings.help.keepOpen': 'Açık tut',
  'loSiteSettings.tabs.identity': 'Kimlik',
  'loSiteSettings.tabs.language': 'Dil',
  'loSiteSettings.tabs.analytics': 'Analitik',
  'loSiteSettings.tabs.domain': 'Alan adı',
  'loSiteSettings.tabs.legal': 'Yasal',
  'loSiteSettings.tabs.branding': 'Beyaz etiket',
  'loSiteSettings.tabs.features': 'Seçenekler',
  'loSiteSettings.tabs.payments': 'Ödemeler',
  'loSiteSettings.domain.configure': 'Yapılandır',
  'loSiteSettings.domain.verify': 'DNS doğrula',
});

loSiteSettingsLocales.zgh = fillFromEn({
  'loSiteSettings.pageTitle': 'Iɣewwaren n usmel',
  'loSiteSettings.save': 'Sekles iɣewwaren',
  'loSiteSettings.help.title': 'Tallelt',
  'loSiteSettings.tabs.identity': 'Tamagit',
  'loSiteSettings.tabs.language': 'Tutlayt',
  'loSiteSettings.tabs.domain': 'Domaine',
  'loSiteSettings.tabs.legal': 'Azref',
  'loSiteSettings.tabs.branding': 'White label',
  'loSiteSettings.tabs.features': 'Tixtiṛiyin',
  'loSiteSettings.tabs.payments': 'Afray',
});
